import { endpoint_host } from '@/config';


export default [
    {
        ids: [15, 29, 31, 33, 50, 54],
        titulo: "Apartamento",
        modalidade: "residencial"
    },
    {
        ids: [33],
        titulo: "Cobertura",
        modalidade: "residencial"
    },
    {
        ids: [10, 12, 14, 26, 27, 28, 42, 44],
        titulo: "Casa",
        modalidade: "residencial"
    },
    {
        ids: [42],
        titulo: "Casa em Condomínio",
        modalidade: "residencial"
    },
    {
        ids: [15, 31, 50, 54],
        titulo: "Kitnet / JK / Flat / Loft / Stúdio",
        modalidade: "residencial"
    },
    {
        ids: [13],
        titulo: "Chácara / Sítio / Fazenda",
        modalidade: "residencial"
    },
    {
        ids: [24, 43],
        titulo: "Lote / Terreno",
        modalidade: "residencial"
    },
    {
        ids: [55],
        titulo: "Depósito",
        modalidade: "comercial"
    },
    {
        ids: [46],
        titulo: "Espaço para antena",
        modalidade: "residencial"
    },
    {
        ids: [18, 37, 49],
        titulo: "Espaço publicitário / Outdoor",
        modalidade: "comercial"
    },

    {
        ids: [8, 30, 38],
        titulo: "Box / Garagem / Estacionamento",
        modalidade: "comercial"
    },
    {
        ids: [9, 10],
        titulo: "Casa Comercial",
        modalidade: "comercial",
    },
    {
        ids: [17],
        titulo: "Loja",
        modalidade: "comercial"
    },
    {
        ids: [19],
        titulo: "Pavilhão",
        modalidade: "comercial"
    },
    {
        ids: [40],
        titulo: "Prédio",
        modalidade: "comercial"
    },
    {
        ids: [41],
        titulo: "Quiosque",
        modalidade: "comercial"
    },
    {
        ids: [20],
        titulo: "Sala Comercial",
        modalidade: "comercial"
    }
];

export const Categorias = (async () => {
    let categorias = await fetch(`${endpoint_host}/categorias-imoveis`).then(resp => resp.json());
    let comercial = categorias.filter(({ comercial }) => comercial).map(categoria => ({
        ids: categoria.ids,
        titulo: categoria.titulo,
        modalidade: 'comercial'
    }));
    let residencial = categorias.filter(({ residencial }) => residencial).map(categoria => ({
        ids: categoria.ids,
        titulo: categoria.titulo,
        modalidade: 'residencial'
    }));
    let prontos = categorias.map(categoria => ({
        ids: categoria.ids,
        titulo: categoria.titulo,
        modalidade: 'prontos'
    }));

    return [
        ...comercial,
        ...residencial,
        ...prontos
    ]
})()